import { render } from "./ProductPage.vue?vue&type=template&id=1e7c3d46"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__